import React from "react";
import { Row, Col } from "antd";
import { FileImageOutlined } from "@ant-design/icons";

function NoImage({ ...props }) {
  return (
    <Row
      justify="center"
      align="middle"
      style={{
        width: "80%",
        aspectRatio: 0.74,
        backgroundColor: "#808080",
        fontSize: "24px",
        margin: "auto",
        textAlign: "center",
      }}
      {...props}
    >
      <Col span={24} style={{ opacity: "0.4" }}>
        <FileImageOutlined style={{ fontSize: "48px" }} />
        <div>Зураггүй</div>
      </Col>
    </Row>
  );
}

export default NoImage;
